import { SIZE } from '../../../constants/size'

export const UPLOAD_IMAGE_BOX_SIZE = SIZE.X_LARGE

export const UPLOAD_IMAGE_ACCEPT = 'image/*'

// Stories/tests seam: forces the modal into a transient state. Not used in production.
export const UPLOAD_IMAGE_PREVIEW_STATE = {
  ERROR: 'error',
  LOADING: 'loading',
  SKELETON: 'skeleton',
}

export const QA_NAME_UPLOAD_IMAGE = 'uploadImage'

export const QA_NAME_UPLOAD_IMAGE_SAVE = 'uploadImageSave'

export const QA_NAME_UPLOAD_IMAGE_CANCEL = 'uploadImageCancel'

export const QA_NAME_UPLOAD_IMAGE_ROTATE = 'uploadImageRotate'

export const QA_NAME_UPLOAD_IMAGE_RELOAD = 'uploadImageReload'

export const QA_NAME_UPLOAD_IMAGE_UNDO = 'uploadImageUndo'

export const QA_NAME_UPLOAD_IMAGE_FILE_INPUT = 'uploadImageFileInput'
